import { forwardRef } from "react";
import { classNames } from "../../utils/classNames";

export const Breadcrumb = forwardRef<
  HTMLElement,
  React.ComponentPropsWithoutRef<"nav">
>(function Breadcrumb({ className, ...props }, ref) {
  return (
    <nav
      ref={ref}
      aria-label="breadcrumb"
      {...props}
      className={classNames("overflow-hidden", className)}
    />
  );
});
